module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "img_slider"
  }, [(_vm.imgs.length > 1) ? [_c('a', {
    staticClass: "prev arrow",
    on: {
      "click": _vm.prev
    }
  }, [_vm._v("❮")]), _c('a', {
    staticClass: "next arrow",
    on: {
      "click": _vm.next
    }
  }, [_vm._v("❯")])] : _vm._e(), _vm._l((_vm.imgs), function(img, index) {
    return [_c('img', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (img.show),
        expression: "img.show"
      }],
      key: index,
      staticClass: "img_icon",
      attrs: {
        "src": img.img,
        "alt": _vm.alt
      }
    })]
  }), (_vm.imgs.length > 1) ? _c('div', {
    staticClass: "slide-numbers"
  }, _vm._l((_vm.imgs), function(img, index) {
    return _c('span', {
      key: index,
      staticClass: "dot",
      class: {
        active: img.show
      },
      on: {
        "click": function($event) {
          return _vm.setImage(index)
        }
      }
    })
  }), 0) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-714a8e12","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/vacancies/slider/Slider.vue
// module id = 56528d438d571373fb3e
// module chunks = 13